import React from 'react';
import { StyleSheet } from 'react-native';

import { PlayerProjectionFragment } from '@/api/events/query.generated';
import { AnimatedNumber } from '@/components/AnimatedNumber';
import { Box, TouchableBox } from '@/components/lib/components';
import { common } from '@/styles/styles';

import { SingleProjectionIcon } from '../lobby/components/SingleProjectionIcon';
import { checkIfRegularProjection } from '../lobby/utils/lineupsUtils';

export const AlternateProjection = ({
    alternateProjection,
    isActive,
    showActiveDot,
    setActiveAlternateIndex,
}: {
    alternateProjection: PlayerProjectionFragment;
    isActive: boolean;
    showActiveDot: boolean;
    setActiveAlternateIndex: () => void;
}) => {
    const isRegularProjection = checkIfRegularProjection(alternateProjection.type);
    return (
        <TouchableBox
            style={[styles.alternateProjectionCard, common.borderCurve]}
            borderWidth={1}
            borderRadius={'r10'}
            borderColor={isActive ? 'white' : 'neutral600'}
            onPress={setActiveAlternateIndex}
            flexDirection={'row'}
            gap={'s8'}
        >
            <AnimatedNumber
                alignText={'flex-start'}
                decimals={1}
                value={(isRegularProjection ? alternateProjection.value : alternateProjection.nonRegularValue) ?? 0}
                color={'white'}
                variant={'labelLarge'}
                letterSpacing={-0.08}
            />
            {!isRegularProjection ? (
                <SingleProjectionIcon selectedProjection={alternateProjection} style={common.selfCenter} />
            ) : null}
            {showActiveDot ? (
                <Box
                    borderWidth={2}
                    borderColor={'neutral800'}
                    borderRadius={'r12'}
                    position={'absolute'}
                    overflow={'hidden'}
                    right={-3}
                    top={-3}
                >
                    <Box width={6} height={6} borderRadius={'r12'} backgroundColor={'white'} />
                </Box>
            ) : null}
        </TouchableBox>
    );
};

const styles = StyleSheet.create({
    alternateProjectionCard: { paddingHorizontal: 13, paddingVertical: 7 },
});
